import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const TrustedBySection = () => {
  const companies = [
    { name: 'Amazon Web Services', logo: 'https://d0.awsstatic.com/logos/powered-by-aws-white.png' },
    { name: 'Stripe', logo: '/partners/Stripe wordmark - white.svg' },
    { name: 'OpenAI ChatGPT', logo: '/partners/OpenAI-white-wordmark.svg' },
    { name: 'Langchain', logo: '/partners/LangChain-logo-white.svg' },
    { name: 'Supabase', logo: '/partners/supabase-logo-wordmark--dark.svg' },
  ];

  return (
    <section className="py-5">
      <Container>
        <h4 className="text-end">Powered by</h4>
        <Row className="justify-content-center">
          {companies.map((company, index) => (
            <Col key={index} xs={6} sm={4} md={3} lg={2} className="d-flex justify-content-center align-items-center">
              <img
                src={company.logo}
                alt={company.name}
                className="img-fluid"
                style={{ 
                  maxHeight: '100px', 
                  objectFit: 'contain', 
                  maxWidth:'100px',
                }}
              />
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default TrustedBySection;
